const FormRouteItemOperational = () =>
  import("../views/routes/FormRouteItemOperational.vue")
const RouteItemCreate = () => import("../views/routes/CreateRouteItem.vue")
const RouteShow = () => import("../views/routes/show.vue")
const RouteIndex = () => import("../views/routes/index.vue")
const RouteRoot = () => import("../views/routes/RoutePage.vue")
const Dashboard = () => import("../views/Dashboard.vue")
const Login = () => import("../views/Login.vue")

export default [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      public: true,
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/routes",
    component: RouteRoot,
    children: [
      {
        path: "",
        component: RouteIndex,
      },
      {
        path: ":route_id",
        component: RouteShow,
      },
      {
        path: ":route_id/route-items/create",
        component: RouteItemCreate,
      },
      {
        path: ":route_id/route-items/:id/sub-process/:sub_process_id",
        component: FormRouteItemOperational,
      },
    ],
  },
]
